import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail3"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.7168 8.2829C5.2705 10.2976 8.49494 11.5 12.0002 11.5C15.5054 11.5 18.7299 10.2976 21.2836 8.2829" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEmail3;
